import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Crowdfunding en Winwinleningen"
      description="Heeft u het afgelopen jaar een lening verstrekt aan startende kleine ondernemingen via een erkend crowdfundingplatform en/of Winwinleningen?"
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <RadioGroupInput
          name="crowdfunding_winwin_lening"
          items={[
            { text: 'Ja', value: 'ja' },
            { text: 'Nee', value: 'nee' },
          ]}
          xs={12}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
